import Header from '../../components/layout/Header/Header';
import Footer from '../../components/layout/Footer/Footer';
import Hero from '../../components/home/Hero/Hero';
import Stats from '../../components/home/Stats/Stats';
import About from '../../components/home/About/About';
import WhyChooseUs from '../../components/home/WhyChooseUs/WhyChooseUs';
import Services from '../../components/home/Services/Services';

function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <WhyChooseUs />
        <Services />
      </main>
      <Footer />
    </>
  );
}

export default Home;
